// extracted by mini-css-extract-plugin
export default {"container":"container___Uhmjk","contract":"contract___SZN0r","header":"header___cN0zX","left":"left___Q8Kbp","footer":"footer___LXjr3"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"container\":\"container___Uhmjk\",\"contract\":\"contract___SZN0r\",\"header\":\"header___cN0zX\",\"left\":\"left___Q8Kbp\",\"footer\":\"footer___LXjr3\"}";
        // 1793018520127
        var cssReload = require("../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  